/**
 * useGetFeedUnreadCount — Read-only accessor for the platform feed's unread badge count.
 *
 * Does NOT fetch from the server. The count is written into the React Query cache
 * by GlobalWebsocketManager when a FEED_EVENT_NEW / STREAM_WENT_LIVE websocket event
 * arrives. Reading from the cache (staleTime: Infinity) avoids any network round-trip
 * and keeps all subscribers in sync via a single shared cache entry.
 */
import {useQuery} from "@tanstack/react-query";

export const FEED_UNREAD_COUNT_QUERY_KEY = Object.freeze(["feed-unread-count"] as const);

export function useGetFeedUnreadCount(): number {
    const {data = 0} = useQuery<number>({
        queryKey: FEED_UNREAD_COUNT_QUERY_KEY,
        queryFn: () => 0,
        staleTime: Infinity,
        gcTime: Infinity,
    });
    return data;
}
